<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent">
  <app-popup-header title="{{localService.languageContent.common.notes}}"></app-popup-header>
  <div class="modal-body modal-body-no-flexible-height">
    <div class="row">
      <div class="col-12 en">
        <textarea id="{{elementIds.txt_comment}}" maxlength="500" rows="6" [(ngModel)]="txtContent" placeholder="Enter your notes here.. Max 500 characters"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>
